import { ReactNode } from "react";
import { Box } from "@mui/material";
import EmployeeAppBar from "./EmployeeAppBar";

interface EmployeeLayoutProps {
  children: ReactNode;
  pageTitle?: string;
}

/**
 * Simplified layout for employees
 * Uses EmployeeAppBar with minimal navigation options
 */
export default function EmployeeLayout({ children }: EmployeeLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: "100vh", bgcolor: "background.default" }}>
      <EmployeeAppBar />
      <Box
        component="main"
        sx={{
          p: { xs: 1.5, sm: 2 },
          mt: { xs: 7, sm: 8 },
          width: "100%",
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
